import React from 'react';
import LazyLoadImg from '~/components/shared/image/LazyLoadImg';
import ConditionalWrapper from '~/components/shared/conditionalWrapper/ConditionalWrapper';
import AnimationPlayer from '../../shared/animationPlayer/AnimationPlayer';

const Item = ({ altText, description, image, link, target, animation }) => {
  const hasAnimation = animation && animation.animationUrl;
  const hasImage = image && image.url;
  const hasMedia = hasAnimation || hasImage;

  return (
    <div className="item">
      <div className="inner">
        {hasMedia && (
          <ConditionalWrapper
            condition={link}
            wrapper={(children) => (
              <a href={link} {...(target && { target })}>
                {children}
              </a>
            )}
          >
            {hasImage ? (
              <LazyLoadImg src={image} alt={altText || 'item icon'} />
            ) : (
              <AnimationPlayer {...animation} />
            )}
          </ConditionalWrapper>
        )}
        {description && <div className="text" dangerouslySetInnerHTML={{ __html: description }} />}
      </div>
    </div>
  );
};

export default Item;
